export default {
  PHONE: 'Phone',
  TABLET: 'Tablet',
  DESKTOP: 'Desktop'
};
